import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import DinamicTableAnalytics from './DinamicTableAnalytics';
import Spinner from '../../utils/Spinner';
import ValidView from "../../../components/app/validView";
import { BodyViewsByPageTitle, BodyUsersByCity, BodyViewsByUserSource, BodyViewsByPages } from './analyticsBodies';

const ModalDetail = ({ show, onHide, pathClient, dates }) => {
  const { allowWrite, allowView, userToken } = ValidView("Reports");
  const [isLoading, setIsLoading] = useState(true);
  const [dataFetched, setDataFetched] = useState(false);

  const [responseViewsByPageTitle, setResponseViewsByPageTitle] = useState({});
  const [responseUsersByCity, setResponseUsersByCity] = useState({});
  const [responseViewsByPages, setResponseViewsByPages] = useState({});
  const [responseViewsByUserSource, setResponseViewsByUserSource] = useState({});
  const styles = { cardContainer: { maxHeight: '580px', overflowY: 'auto', marginBottom: '20px' } };

  const fetchData = async (body, endpoint, setter) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userToken
        },
        body: JSON.stringify(body)
      };

      const response = await fetch(endpoint, requestOptions);
      if (response.ok && (response.status === 200 || response.status === 201)) {
        const data = await response.json();
        setter(data);
      } else {
        console.error('Error fetching data. Status:', response.status);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const customDimensionFilter = {
    filter: {
      stringFilter: {
        matchType: "CONTAINS",
        value: pathClient
      },
      fieldName: "hostName"
    }
  };

  const endpointStandard = process.env.REACT_APP_NERTHUS_API_URL + '/reports/analyticsReports?type=standard';
  const startDateFormatted = dates.startDate.toISOString().split('T')[0];
  const endDateFormatted = dates.endDate.toISOString().split('T')[0];

  const fetchAnalyticsData = async () => {
    await Promise.all([
      fetchData(BodyViewsByPageTitle(startDateFormatted, endDateFormatted, customDimensionFilter), endpointStandard, setResponseViewsByPageTitle),
      fetchData(BodyUsersByCity(startDateFormatted, endDateFormatted, customDimensionFilter), endpointStandard, setResponseUsersByCity),
      fetchData(BodyViewsByPages(startDateFormatted, endDateFormatted, customDimensionFilter), endpointStandard, setResponseViewsByPages),
      fetchData(BodyViewsByUserSource(startDateFormatted, endDateFormatted, customDimensionFilter), endpointStandard, setResponseViewsByUserSource)
    ]);
    setIsLoading(false);
  };

  useEffect(() => {
    if (userToken && show) {
      setIsLoading(true);
      fetchAnalyticsData().then(() => {
        setIsLoading(false);
        setDataFetched(true);
      });
    } else {
      setDataFetched(false);
      setResponseViewsByPageTitle({});
      setResponseUsersByCity({});
      setResponseViewsByUserSource({});
      setResponseViewsByPages({});
    }
  }, [userToken, show]);

  return (
    <>
      <Modal size='xl' show={show} onHide={onHide} dialogClassName="modal-80w" aria-labelledby="modal-styling-title">
        <Modal.Header closeButton>
          <Modal.Title id="modal-styling-title"> <b>{pathClient}</b> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? <Spinner /> : null}
          {dataFetched ? (
            <Container fluid className='dashboard'>
              <Row>
                <Col md={4} className='sidebar'>
                  <Card className='card' border='primary' style={styles.cardContainer}>
                    <Card.Header> UserSource
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <DinamicTableAnalytics data={responseViewsByUserSource.data} />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4} className='sidebar'>
                  <Card className='card' border='primary' style={styles.cardContainer}>
                    <Card.Header> Views By Pages
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <DinamicTableAnalytics data={responseViewsByPages.data} />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={4}>
                  <Card className='card' border='primary' style={styles.cardContainer}>
                    <Card.Header>UsersByCity
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <DinamicTableAnalytics data={responseUsersByCity.data} />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          ) : null}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalDetail;